import React from 'react';
import { Link } from 'react-router-dom';
import Header from "../../components/Header/index";
import moment from 'moment';
import withAuth from "../../services/withAuth";
import LoadingSpinner from "../../components/LoadingSpinner";
import RecentEvent from "./components/RecentEvent";
import AuthApi from "../../services/portal-api/AuthApi";
import { IT_SUPPORT_EMAIL, LOYALTY_SUPPORT_EMAIL } from "../../helpers/Constants";
import AuthService from "../../services/AuthService";
import NotFound from "../NotFound";
import News from './components/news';
import GlobalsApi from "../../services/portal-api/GlobalsApi";

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        this.state = {
            isLoadingRecentEvents: true,
            recentEvents: [],
            recentEventsError: null,
            storeSelected: false,
            news: []
        };
    }

    componentDidMount() {
        document.title = 'Dashboard - duskPortal';
        document.body.className = '';
        // Recent activity
        this.getRecentActivityCallId = AuthApi.getRecentActivity(true, (result, callId) => {

            // Check if we're still interested in this response
            if (callId !== this.getRecentActivityCallId) {
                return;
            }

            // Check for auth
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingRecentEvents: false,
                });
                return;
            }

            this.setState({
                isLoadingRecentEvents: false,
                recentEvents: result.json.events
            });

            // If that result set came from catch, now fetch a non-cached version
            if (!result.isCachedResponse) {
                return;
            }

            this.getRecentActivityCallId = AuthApi.getRecentActivity(false, (result, callId) => {

                // Check if we're still interested in this response
                if (callId !== this.getRecentActivityCallId) {
                    return;
                }

                // Check for auth
                if (result.status === 401) {
                    this.props.sessionExpired();
                    return;
                }

                this.setState({
                    recentEvents: result.json.events
                });
            });
        });

        this.news();
    }

    componentWillUnmount() {
        // No longer care about any API calls in progress
        this.getRecentActivityCallId = null;
    }   

    news = () => {
        GlobalsApi.getNews((result) => {
            this.setState({ 
                news: result.json
            });
        });
    }

    render() {
        const recentActivity = [];
        this.state.recentEvents.forEach((event) => {
            recentActivity.push(<RecentEvent key={event.id} event={event} />);
        });

        let storesOption = [];
        if (AuthService.getDoNotRefreshStoreSelection() != "") {
            const parsedData = JSON.parse(AuthService.getDoNotRefreshStoreSelection());
            if (parsedData != null) {
                console.log("parsedData ", parsedData);
                parsedData.forEach(store => {
                    storesOption.push({ key: store.storeId, value: store.storeName });
                })
            }
        }

        return (
            AuthService.can('home') ?
                <div>
                    <Header />
                    <main className="content" role="main">

                        <div className="col--main clearfix">
                            <div className="col--main__wrap">

                                <div className="alert alert--w-icon">
                                    <div className="icon">
                                        <img src="/img/icon-alert--red.svg" alt="" className="icon__alert" />
                                    </div>
                                    <p>
                                        Welcome to the duskPortal! If you are having any issues with the portal, please contact <a href='https://forms.monday.com/forms/af82bda36d0515ad607def5b9419d60f?r=use1' target="_blank">loyalty support</a>.
                                    </p>
                                </div>

                                <h2 className="u-vis-hide">How can we help?</h2>
                                <div className="col-2-flex gutter--20 margin--40">
                                    <div className="col">

                                        <Link to="/giftcards" className="card--cta card--cta--purple">
                                            <div className="card--cta__icon">
                                                <img src="/img/icon-giftcard--white.svg" alt="" width="75" height="60" className="icon" />
                                            </div>
                                            <h3 className="card--cta__title">Gift Card Lookup</h3>
                                            <p className="text--caps text--muted"><small>Press G</small></p>
                                        </Link>

                                    </div>

                                    <div className="col">

                                        <Link to="/members" className="card--cta card--cta--blue">
                                            <div className="card--cta__icon">
                                                <img src="/img/icon-lookup--white.svg" alt="" width="73" height="73" className="icon" />
                                            </div>
                                            <h3 className="card--cta__title">Member Lookup</h3>
                                            <p className="text--caps text--muted"><small>Press M</small></p>
                                        </Link>

                                    </div>

                                    <div className="col">

                                        <Link to="/new-member" className="card--cta card--cta--green">
                                            <div className="card--cta__icon">
                                                <img src="/img/icon-createMember--white.svg" alt="" width="68" height="68" className="icon" />
                                            </div>
                                            <h3 className="card--cta__title">New Member</h3>
                                            <p className="text--caps text--muted"><small>Press N</small></p>
                                        </Link>

                                    </div>

                                    {/*<div className="col">

                                        <a href="#" className="card--cta card--cta--yellow">
                                            <div className="card--cta__icon">
                                            <img src="/img/icon-giftcard--white.svg" alt="" width="75" height="60" className="icon" />
                                            </div>
                                            <h3 className="card--cta__title">Order Rewards Cards</h3>
                                            <p className="text--caps text--muted"><small>Press O</small></p>
                                        </a>

                                    </div>

                                    <div className="col">

                                        <a href="#" className="card--cta card--cta--red">
                                            <div className="card--cta__icon">
                                                <img src="/img/icon-giftcard--white.svg" alt="" width="75" height="60" className="icon" />
                                            </div>
                                            <h3 className="card--cta__title">Two col button text</h3>
                                            <p className="text--caps text--muted"><small>Press L</small></p>
                                        </a>

                                    </div>*/}

                                </div>



                            </div>
                        </div>

                        <div className="col--sidebar">
                            <div className="col--sidebar__wrap">

                                <div className="margin--40--bot">
                                    <h2 className="u-vis-hide">duskPortal Sidebar</h2>
                                    <h3 className="sub-title text--muted">Recent Activity</h3>
                                    <ul className="list--box list--actions">
                                        {recentActivity}
                                        {!this.state.isLoadingRecentEvents && recentActivity.length === 0 && <li>
                                            <p className="text--13 list--actions--empty"><em>No recent activity.</em></p>
                                        </li>}
                                        {this.state.isLoadingRecentEvents && <li>
                                            <LoadingSpinner isVisible={true} />
                                        </li>}
                                    </ul>
                                </div>

                                <News 
                                    recentNews={this.state.news}
                                />

                            </div>
                        </div>

                    </main>
                </div> 
            :
                <NotFound forbidden={true} />
        );
    }
}

export default withAuth(Dashboard);